import { useMutation } from "@apollo/client";

import { ProjectReviewVisitV2Screen_UpdateWorkerReportDocument } from "../../../mutations.generated";
import { WeatherConditionValues } from "../components/WeatherReportTableRow";
import { ProjectReviewVisitV2WeatherReportsRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2WeatherReportsRoute_UpdateConditions() {
    const [mutate, { loading, error }] = useMutation(ProjectReviewVisitV2Screen_UpdateWorkerReportDocument, {
        refetchQueries: [ProjectReviewVisitV2WeatherReportsRoute_GetDataDocument],
    });

    const updateConditions = async (sourceReportId: string, values: WeatherConditionValues) => {
        await mutate({
            variables: {
                input: {
                    plannerVisitWorkerReportId: sourceReportId,
                    startFormConditions: values.startFormCondition ? [values.startFormCondition] : undefined,
                    submittedFormConditions: values.submittedFormCondition
                        ? [values.submittedFormCondition]
                        : undefined,
                },
            },
        });
    };

    return { updateConditions, loading, error };
}
